export enum ESavedSearchActions {
    Update = "saved-search-update-action",
    Save = "saved-search-save-action",
}
